<div [hidden]="!loading" class="page-loader text-center">
    <div class="loader"></div>
</div>

@if (post$ | async; as post) {
    <div class="container">
        <ul
            class="breadcrumbs"
            [style.margin]="config.theme?.['breadcrumbs']?.reduceMargin ? '1rem 0' : null"
            [style.--breadcrumb-color]="config.theme?.['breadcrumbs']?.textColor || null"
            [style.--breadcrumb-separator-content]="config.theme?.['breadcrumbs']?.icon ? '\'\'' : null"
            [style.--breadcrumb-separator-bg]="
                config.theme?.['breadcrumbs']?.icon ? 'url(' + config.theme?.['breadcrumbs']?.icon + ')' : null
            "
            [style.--breadcrumb-separator-width]="config.theme?.['breadcrumbs']?.icon ? '20px' : null"
            [style.--breadcrumb-separator-height]="config.theme?.['breadcrumbs']?.icon ? '20px' : null"
            [style.--breadcrumb-separator-top]="config.theme?.['breadcrumbs']?.icon ? '50%' : null"
            [style.--breadcrumb-separator-transform]="config.theme?.['breadcrumbs']?.icon ? 'translateY(-50%)' : null">
            <li>
                <a [core-analytics]="{ action: 'Home', category: 'POST' }" routerLink="/">Home</a>
            </li>
            <li>
                <a
                    [core-analytics]="{ action: postLabel | titlecase, category: 'POST' }"
                    [routerLink]="postBreadcrumbLink"
                    [innerText]="postLabel | titlecase"></a>
            </li>
            <li [innerText]="post.name"></li>
        </ul>
        <h1 [innerText]="post.name" class="post-h1"></h1>
        <div class="lead">
            <p [innerHTML]="post.description"></p>
        </div>
        <div class="content-section">
            <div [innerHTML]="post.content"></div>
        </div>
    </div>
}
